import React from "react";
import { useHistory } from "react-router-dom";

import { Table } from "src/library/components/Tables";
import {
  IPaymentCard,
  usePaymentApi
} from "src/modules/payment/api/payment.api";
import {
  FilterParams,
  ITerminology,
  PaginatedParams
} from "src/library/utils";
import { PaymentTransaction } from "src/modules/payment/api/transactions.api";
import { ITableInstance } from "src/library/components/Tables/Table";
import { Button } from "src/library/components/Button";
import { paymentTransactionTableColumns } from "src/core/shared/components/tables/PaymentTransactionColumns";

import { useTransactionApi } from "../../api/transactions.api";

export interface TransactionsTabProps {
  paymentMethod?: IPaymentCard;
  terminology: ITerminology;
}

const TransactionsTab: React.FunctionComponent<TransactionsTabProps> = ({ paymentMethod, terminology }) => {
  const TableRef = React.useRef<ITableInstance<PaymentTransaction>>(null);
  const [ listPaymentCardTransactionsRes, listPaymentCardTransactionsReq ] = usePaymentApi("GET_PAYMENT_METHOD_TRANSACTIONS");
  const [ listTransactionsRes, listTransactionsReq ] = useTransactionApi("LIST_TRANSACTIONS");
  const history = useHistory();

  const onFetchTransactionData = React.useCallback((filters: FilterParams<PaymentTransaction>, pagination: PaginatedParams<PaymentTransaction>) => {
    if (paymentMethod) {
      listPaymentCardTransactionsReq({
        paymentMethodId: paymentMethod?.id,
        params: {
          filters,
          pagination
        }
      });
    } else {
      listTransactionsReq({
        filters,
        pagination
      });
    }
  }, [
    listPaymentCardTransactionsReq,
    listTransactionsReq,
    paymentMethod
  ]);

  const transactionsResponseData = React.useMemo(() => listPaymentCardTransactionsRes.data || listTransactionsRes.data, [ listPaymentCardTransactionsRes, listTransactionsRes ]);
  const transactionsResponseError = React.useMemo(() => listPaymentCardTransactionsRes.error || listTransactionsRes.error, [ listPaymentCardTransactionsRes, listTransactionsRes ]);
  const transactionsResponseLoading = React.useMemo(() => listPaymentCardTransactionsRes.pending || listTransactionsRes.pending, [ listPaymentCardTransactionsRes, listTransactionsRes ]);

  return (
    <>
      <Table
        ref={TableRef}
        tableId="transactions"
        loading={transactionsResponseLoading}
        tableOf={terminology?.order?.plural?.text || "Payments"}
        view="list"
        viewAllowedToToggle
        data={transactionsResponseData ? transactionsResponseData.result : []}
        error={transactionsResponseError}
        onFetchData={onFetchTransactionData}
        defaultPagination={{
          page: 0,
          limit: 10,
          offset: 0,
          sort: [ [ "id", "DESC" ] ]
        }}
        pages={transactionsResponseData?.pages || 0}
        totalRows={transactionsResponseData?.count || 0}
        columns={paymentTransactionTableColumns({
          terminology,
          Button: row => (
            <Button
              type="button"
              onClick={() => history.push(`/orders/${(row.original).orderId}`)}
            >
              View order
            </Button>
          )
        })}
      />

    </>
  );
};

export default TransactionsTab;
